import { createFileRoute, redirect } from "@tanstack/react-router";
import { useStore } from "zustand";
import { uiStore } from "@/lib/stores/ui-store";

export const Route = createFileRoute("/app/$channelId/thread/$threadId")({
	component: ThreadComponent,
});

function ThreadComponent() {
	const { channelId, threadId } = Route.useParams();
	const navigate = useStore(uiStore, (state) => state.navigate);
	navigate({ type: "thread", params: { channelId, threadId } });
	throw redirect({ to: "/app" });
}
